module.exports = __webpack_public_path__ + "img/Logo BUP dan BP.56be4de2.png";